import { appraisal } from './appraisal'

const forwarder = {
  appraiser_appraisals: appraisal,
}
export default forwarder
